import { getTranslation, getEntityName } from "@/utils";

interface IFormHeaderProps {
  selectedEntity: string;
}

const FormHeader = ({ selectedEntity }: IFormHeaderProps) => {
  return (
    <div className="header">
      <div>
        <span className="header-title">
          {getTranslation(
            "sections.edit-form.project-settings-part2",
            "Forms Layout Edit",
          )}{" "}
          - {getEntityName(selectedEntity, "singular-name")}
        </span>
      </div>
    </div>
  );
};

export default FormHeader;
